import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import PasswordChecklist from "react-password-checklist";
import CvInsert from "./CvInsert";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";

const Dashboard = () => {
  const [user_details, setUserDetails] = useState();
  const navigate = useNavigate();
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(false); 
  const [jwtToken] = useState(localStorage.getItem("jwt") || "");

  const [value, setValue] = useState({
    firstName: user_details && user_details.firstName,
    lastName: "",
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword:""
  });

  useEffect(() => {
    axios
      .get("https://www.turanozbahceci.com/api/profile.php", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setUserDetails(res.data.user);
        setValue((prevState) => ({
          ...prevState,
          firstName: res.data.user.firstName,
          lastName: res.data.user.lastName, 
          email:res.data.user.email,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "confirmPassword" || name === "newPassword") {
      if (value.newPassword === value.confirmPassword) {
        setIsPasswordConfirmed(true); // Set to true if passwords match
      } else {
        setIsPasswordConfirmed(false); // Set to false if passwords don't match
      }
    }
  };

  const handleLogout = () => {
    // JWT-ni silirik
    localStorage.removeItem("jwt");
    window.dispatchEvent(new Event("storage"));
  
    // Yenilənmiş məlumatların tətbiq olunması üçün səhifəni yeniləyirik
    setTimeout(() => {
      window.location.reload(); // səhifəni yeniləyirik
      navigate("/"); // Yenidən yönləndirmə
    }, 100); // 100ms gecikmə ilə
  };
  

 const handleSubmit=(e)=>{
  e.preventDefault() 
  axios.post("https://www.turanozbahceci.com/api/profile.php",{
    firstName: value.firstName,
    lastName: value.lastName,
    email: value.email,
    oldPassword: value.oldPassword,  
    newPassword: value.newPassword 
    
  },{
    headers: {
      Authorization: `Bearer ${jwtToken}`,
      "Content-Type": "application/json",
    },
  })
  .then((res)=>{
  
    window.location.reload()
  })
  .catch((err)=>{
    console.log(err);
  })
 }


  return (
    <>
      <div className="my-account-section section section-padding-bottom">
        <div className="section-title">
          <h2 className="title text-center my-5 fz-48">
           {t.welcome} <span>{t.welcome1}</span>
          </h2>
        </div>
        {user_details && user_details.subscription == "1" ? (
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {/* My Account Tab Menu Start */}
                  <div className="col-lg-3 col-12">
                    <div className="myaccount-tab-menu nav" role="tablist">
                      <a href="#" className="active" data-bs-toggle="tab">
                        <i className="fas fa-tachometer-alt-slow" />
                        {user_details.firstName} {user_details.lastName}
                      </a>
                      <a href="#orders" data-bs-toggle="tab">
                        <i className="fa fa-cart-arrow-down" /> {t.karyerairelileyis}
                      </a>
                      {/* <a href="#download" data-bs-toggle="tab">
                      <i className="fa fa-download" /> Download
                    </a>
                    <a href="#payment-method" data-bs-toggle="tab">
                      <i className="fa fa-credit-card" /> Payment Method
                    </a> */}
                      <a href="#address-edit" data-bs-toggle="tab">
                        <i className="fa fa-map-marker" /> {t.address}
                      </a>
                      <a href="#account-info" data-bs-toggle="tab">
                        <i className="fa fa-user" /> {t.hesabmelumatlari}
                      </a>
                      <NavLink to="/" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt" /> {t.logout}
                      </NavLink>
                    </div>
                  </div>
                  {/* My Account Tab Menu End */}
                  {/* My Account Tab Content Start */}
                  <div className="col-lg-9 col-12">
                    <div className="tab-content" id="myaccountContent">
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade show active"
                        id="dashboad"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          {/* <h3>Admin panel</h3> */}
                          <div className="welcome mb-20">
                            <p className="fs-5">
                              {t.hello}{" "}
                              <strong>
                                {" "}
                                {user_details.firstName} {user_details.lastName}{" "}
                                !
                              </strong>
                            </p>
                          </div>
                          <p className="mb-0">
                           {t.paneldesc}
                          </p>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade"
                        id="orders"
                        role="tabpanel"
                      >
                       <CvInsert/>
                      </div>
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
               
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade"
                        id="payment-method"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>Payment Method</h3>
                          <p className="saved-message">
                            You Can't Saved Your Payment Method yet.
                          </p>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade"
                        id="address-edit"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>{t.address}</h3>
                          <address>
                            <p>
                              <strong>
                                {t.username} {user_details.firstName}{" "}
                                {user_details.lastName}
                              </strong>
                            </p>
                            <p>{t.mobil} : {user_details.mobile} </p>
                          </address>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                      {/* Single Tab Content Start */}
                      <div
                        className="tab-pane fade"
                        id="account-info"
                        role="tabpanel"
                      >
                        <div className="myaccount-content">
                          <h3>{t.hesabmelumatlari}</h3>
                          <div className="account-details-form">
                            <form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-lg-6 col-12 mb-30">
                                  <label htmlFor="">{t.name}</label>
                                  <input
                                    id="first-name"
                                    placeholder={t.name}
                                    name="firstName"
                                    type="text"
                                    value={value.firstName}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <label htmlFor="">{t.lastname}</label>
                                  <input
                                    id="last-name"
                                    placeholder={t.lastname}
                                    type="text"
                                    name="lastName"
                                    value={value.lastName}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-6 mb-30">
                                  <label htmlFor="">{t.email}</label>
                                  <input
                                    id="email"
                                    placeholder={t.email}
                                    type="email"
                                    name="email"
                                    value={value.email}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-6 mb-30">
                                  <label htmlFor="">{t.subscribe}</label>
                                  <input
                                    id="email"
                                    placeholder={t.subscribe}
                                    type="email"
                                    className="user_details_subs"
                                    disabled
                                    value={
                                      user_details.subscription == "0"
                                        ? t.kouc
                                        : user_details.subscription == "1"
                                        ? t.isimkanlari
                                        : t.subsemek
                                    }
                                  />
                                </div>
                                <div className="col-12 mb-30">
                                  <h4>{t.sifreniyenile}</h4>
                                </div>
                                <div className="col-12 mb-30">
                                  <input
                                    id="current-pwd"
                                    placeholder={t.hazirki}
                                    type="text"
                                    name="oldPassword"
                                    onChange={handleChange}
                                  />
                                  <div
                                    className={`${
                                      !value.oldPassword && "d-none"
                                    }`}
                                  >
                                    <PasswordChecklist
                                      rules={[
                                        "minLength",
                                        "specialChar",
                                        "number",
                                        "capital",
                                        "lowercase",
                                        "oneSpecialChar",
                                        "noSpaces",
                                        "noUsername",
                                        "custom",
                                      ]}
                                      className="mb-5"
                                      minLength={8}
                                      value={value.oldPassword}
                                      onChange={(isValid) =>
                                        setIsPasswordValid(isValid)
                                      }
                                      messages={{
                                        minLength:
                                          "Şifrə ən az 8 simvoldan ibarət olmalıdır.",
                                        specialChar:
                                          "Şifrə xüsusi simvollar içerməlidir.",
                                        number: "Şifrə rəqəm içerməlidir.",
                                        capital:
                                          "Şifrə böyük hərf içerməlidir.",
                                        lowercase:
                                          "Şifrə kiçik hərf içerməlidir.",
                                        oneSpecialChar:
                                          "Şifrə ən az bir xüsusi simvol içerməlidir.",
                                        noSpaces: "Şifrə boşluq içerməməlidir.",
                                        noUsername:
                                          "Şifrə istifadəçi adını içerməməlidir.",
                                        custom:
                                          "Şifrə xüsusi bir şərtə cavab verməlidir.",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <input
                                    id="new-pwd"
                                    placeholder={t.yeni}
                                    type="text"
                                    disabled={!isPasswordValid} 
                                    name="confirmPassword"
                                    value={value.confirmPassword}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col-lg-6 col-12 mb-30">
                                  <input
                                    id="confirm-pwd"
                                    placeholder={t.sifretestiq}
                                    type="text"
                                    name="newPassword"
                                    disabled={!isPasswordValid} 
                                    onChange={handleChange}
                                  />
                                  {
                                    value.confirmPassword !== value.newPassword ? <span className="text-danger">Şifrələr eyni deyil</span> : ""
                                  }
                                </div>
                                <div className="col-12">
                                  <button type="submit" className="btn btn-primary btn-hover-secondary">
                                    {t.yerlesdirin}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      {/* Single Tab Content End */}
                    </div>
                  </div>
                  {/* My Account Tab Content End */}
                </div>
              </div>
            </div>
          </div>
        )
      : ""
      }
      </div>
    </>
  );
};

export default Dashboard;
